import HomePage from "./components/HomePage";
import PageNotFound from "./components/PageNotFound";
import Statistics from "./components/Statistics";
import Pay from "./components/Pay";
import Profile from "./components/Profile";
import Timetable from "./components/Timetable";
import PPGeneration from "./components/PPGeneration";

export const routes = [
    {
        name: 'home',
        path: '/home/',
        component: HomePage
    },
    {
        name: 'statistics',
        path: '/home/statistics',
        component: Statistics
    },
    {
        name: 'pay',
        path: '/home/pay',
        component: Pay
    },
    {
        name: 'timetable',
        path: '/home/timetable',
        component: Timetable
    },
    {
        name: 'profile',
        path: '/home/profile',
        component: Profile
    },
    {
        name: 'ppg',
        path: '/home/pp_generation',
        component: PPGeneration
    },
    {
        name: '404',
        path: '/home/*',
        component: PageNotFound
    }
];
